import { Model } from 'pinia-orm';
import Application from './Application';
import User from './User';
import Document from "./Document";
import Interview from "./Interview";
import Contact from "./Contact";
import Comment from "./Comment";
import Invitation from "./Invitation";
import Task from "./Task";
import InboundEmail from "./InboundEmail";

export default class TimelineEvent extends Model {

    static get entity() {
        return 'timeline_events'
    }

    static fields() {
        return {
            id: this.uid(),
            application_id: this.number(null),
            user_id: this.number(null),
            action: this.string(''),
            data: this.attr({}),
            eventable_id: this.attr(null),
            eventable_type: this.attr(null),
            created_at: this.attr(null),
            eventable: this.morphTo([Application, Document, Interview, Contact, Comment, Invitation, Task, InboundEmail], 'eventable_id', 'eventable_type'),
            application: this.belongsTo(Application, 'application_id'),

            //relations
            user: this.belongsTo(User, 'user_id')
        }
    }
}
